<template>
    <div id="calMgmtBox">        
        <div class="searchWrap">
            <div class="row">
                <div class="itemWrap" v-if="divBtnVisible">
                    <label>區處部門：</label>
                    <DivSelection v-model="selectedDiv" :noDivision="true" :filterDivisionCode="filterDivisionCode" @branch-selected="handleDivChange" style="margin-right: 1rem;" />
                </div>
                <div class="itemWrap">
                    <label>選擇年月：</label>
                    <el-date-picker
                        v-model="selyyyyMM"
                        type="month"
                        format="yyyy-MM"
                        value-format="yyyy-MM"
                        placeholder="選擇年月"
                        @change="changeYYYYMM"
                        style="margin-right: 20px">
                    </el-date-picker>                    
                </div>                
                <div class="itemWrap">
                    <label>業務人員：</label>
                    <el-select v-model="selSales" placeholder="請選擇分類" no-data-text="無數據" clearable style="width: 200px;">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option :label="item.UserName" :value="item.UserID" v-for="item in branchStaffList" :key="item.ID"></el-option>
                    </el-select>
                </div>
                <div class="itemWrap">
                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                </div>
            </div>
        </div>       
        
        <div class="content">
            <div class="legend">

                <div class="legendItem" v-for="(item, index) in salesList" :key="item.empID">
                    <div class="legend-color" :class="getColorClass(index)">{{ item.empName }}</div>
                </div>
            </div>
            <el-calendar v-model="yyyyMM">
                <template slot="dateCell" slot-scope="{data}">
                    <div class="main-cd" @click="calClick" @contextmenu.prevent="showContextMenu($event, data)">
                        <div class="date-number" :class="data.isSelected ? 'is-selected' : ''">
                            {{ data.day.split('-').slice(2).join('-') }}                         
                        </div>
                        <div class="event-container">
                            <template v-if="getDateEvents(data.day).length > 0">
                                <div class="day-events">
                                    <div v-for="(group, colorClass) in groupEventsByColor(data.day)" 
                                        :key="colorClass" 
                                        class="event-group"
                                        :class="colorClass">
                                        <el-tooltip 
                                            v-for="(item, idx) in group" 
                                            :key="idx" 
                                            effect="light" 
                                            :content="`業務人員: ${item.sales}${item.startTime && item.endTime ? '\n時間: ' + item.startTime + ' 至 ' + item.endTime : ''}`"
                                            placement="top"
                                            :open-delay="300">
                                            <span 
                                                class="customer-tag"
                                                @click.stop="calClick(item)" 
                                                @contextmenu.stop.prevent="showContextMenu($event, data, item)">
                                                {{ item.source === 'case' ? getCaseTimeTag(item.startTime) + truncateText(item.target, 6) : truncateText(item.title, 6) }}
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div v-if="getHiddenEventsCount(data.day) > 0" class="more-events">
                                    共計 {{ getDateEvents(data.day).length }} 件
                                </div>
                            </template>
                        </div>                           
                    </div>
                </template>
            </el-calendar>
            
            <!-- el-calendar 右鍵內容菜單 -->
            <div class="context-menu" v-show="showMenu" :style="{top: menuTop + 'px', left: menuLeft + 'px'}">
                <div class="menu-Title">行事曆選項</div>
                <ul>
                    <li @click="handleContextMenu('add')" >
                        <i class="el-icon-plus menu-icon"></i>新增行事曆
                    </li>
                    <li @click="handleContextMenu('edit')">
                        <i class="el-icon-edit menu-icon"></i>編輯行事曆
                    </li>
                </ul>
            </div>
        </div>
        
        <!-- 新增行事曆的抽屜 -->
        <el-drawer
            Title="新增行程"
            :visible.sync="drawerVisible"
            direction="rtl"
            size="30%">
            <div class="drawer-content">
                <div class="form-item">
                    <label>日期</label>
                    <el-date-picker
                        v-model="scheduleForm.date"
                        type="date"
                        placeholder="選擇日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 100%">
                    </el-date-picker>
                </div>

                <div class="form-item">
                    <label>時間</label>
                    <div style="display: flex; width: 100%; align-items: center;">
                        <el-time-picker
                            v-model="scheduleForm.startTime"
                            placeholder="開始時間"
                            format="HH:mm"
                            value-format="HH:mm"
                            :picker-options="{
                                selectableRange: '00:00:00 - 23:59:59'
                            }"
                            style="width: 48%;">
                        </el-time-picker>
                        <span style="margin: 0 4% 0 4%; text-align: center;">至</span>
                        <el-time-picker
                            v-model="scheduleForm.endTime"
                            placeholder="結束時間"
                            format="HH:mm"
                            value-format="HH:mm"
                            :picker-options="{
                                selectableRange: '00:00:00 - 23:59:59'
                            }"
                            style="width: 48%;">
                        </el-time-picker>
                    </div>
                </div>                

                <div class="form-item">
                    <label>事由</label>
                    <el-input placeholder="請輸入事由" 
                    v-model="scheduleForm.target"
                    :maxlength="100"
                    show-word-limit></el-input>
                    
                </div>
                
                <div class="form-item">
                    <label>備註</label>
                    <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="請輸入備註"
                        :maxlength="100"
                        show-word-limit
                        v-model="scheduleForm.Memo">
                    </el-input>
                </div>
                
                <div class="form-actions">
                    <el-button @click="drawerVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveSchedule">儲存</el-button>
                </div>
            </div>
        </el-drawer>

        <!-- 編輯行程抽屜 -->
        <el-drawer
            Title="編輯行程"
            :visible.sync="editDrawerVisible"
            direction="rtl"
            size="30%">
            <div class="drawer-content">
                <h3>{{ selectedDate }} 行程列表</h3>
                <div v-if="dayEvents.length === 0" class="no-events">
                    當天沒有行程
                </div>
                <div v-else class="day-events-list">
                    <div 
                        v-for="(event, index) in dayEvents" 
                        :key="index"
                        class="event-item"
                        :class="getSalesColor(event.sales, event.date)">
                        <div class="event-content" style="margin-right:10px;">
                            <div class="event-header">
                                <span class="event-Title">{{ event.source === 'case' ? event.target : event.title }}</span>
                                <span class="event-status" v-if="event.caseSource">{{ event.caseSource }}</span>
                                <span class="event-status" v-if="event.status">{{ event.status }}</span>
                            </div>
                            <div class="event-details">
                                <div>業務人員：{{ event.sales }}</div>
                                <div v-if="event.startTime && event.endTime">時間：{{ event.startTime }} 至 {{ event.endTime }}</div>
                                <div v-if="event.memo">備註：{{ event.memo }}</div>
                            </div>
                        </div>
                        <div class="event-actions">
                            <el-button 
                                type="primary" 
                                icon="el-icon-edit" 
                                size="mini"
                                style="width: 80px;"
                                :disabled="!canEditEvent(event)"
                                @click="editCaseOrSchedule(event, index)">
                                編輯
                            </el-button>
                            <el-button 
                                v-if="event.source == 'calendar'"
                                type="danger" 
                                icon="el-icon-delete" 
                                size="mini"
                                style="width: 80px;"
                                :disabled="!canEditEvent(event)"
                                @click="confirmDeleteEvent(index)">
                                刪除
                            </el-button>
                        </div>
                    </div>
                </div>
                <div class="form-actions">
                    <el-button @click="editDrawerVisible = false" type="primary">關閉</el-button>
                </div>
            </div>
        </el-drawer>


        <el-dialog title="案件編輯" :visible.sync="showCaseEdit" width="70%" center>
            <div class="dialogBox">
                <div class="details-container">
                    <div class="detail-row">
                        <div class="detail-label">案件編號</div>
                        <div class="detail-content">{{ caseDetails[0] && caseDetails[0].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">到期日/限辦日期</div>
                        <div class="detail-content">{{ caseDetails[1] && caseDetails[1].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">統一編號</div>
                        <div class="detail-content">{{ caseDetails[2] && caseDetails[2].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">公司名稱</div>
                        <div class="detail-content">{{ caseDetails[3] && caseDetails[3].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">資料來源</div>
                        <div class="detail-content">{{ caseDetails[4] && caseDetails[4].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">專案名稱</div>
                        <div class="detail-content">{{ caseDetails[5] && caseDetails[5].value }}</div>
                    </div>
                    <div class="detail-row" >
                        <div class="detail-label">案件狀態</div>
                        <div class="detail-content" >
                            <el-select  v-model="caseDetails[6].value" placeholder="請選擇案件狀態" @change="checkReason">
                                <el-option v-for="(options, index) in nextSelectList" :key="index" :value="options"></el-option>
                            </el-select>
                            <el-select v-if="showReason" v-model="caseDetails[14].value" placeholder="請選擇原因" style="margin-left:10px;">
                                <el-option v-for="(options, index) in selectedReason" :key="index" :label="options" :value="options"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">預計訪視時間</div>
                        <div class="detail-content" >
                            <el-date-picker v-if="caseDetails[7]" v-model="caseDetails[7].value" type="date" size="small" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>                            
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">區處</div>
                        <div class="detail-content">{{ caseDetails[8] && caseDetails[8].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">分行名稱</div>
                        <div class="detail-content">{{ caseDetails[9] && caseDetails[9].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">覆核主管</div>
                        <div class="detail-content">{{ caseDetails[10] && caseDetails[10].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">承辦人</div>
                        <div class="detail-content">{{ caseDetails[11] && caseDetails[11].value }}</div>                        
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">建立時間</div>
                        <div class="detail-content">{{ caseDetails[12] && caseDetails[12].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">備註</div>
                        <div class="detail-content">
                            <el-input v-if="caseDetails[13]" v-model="caseDetails[13].value" type="textarea" rows="2" size="small" style="width: 100%;"></el-input>
                            
                        </div>
                    </div>
                </div>  
            </div>
            <span slot="footer" class="dialog-footer">                                
                <el-button type="danger" @click="btnSaveDetail()"><font-awesome-icon icon="plus" style="margin-right:5px;" />儲存</el-button>                
                <el-button type="danger" @click="showCaseEdit=false"><font-awesome-icon icon="times" style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>          
    </div>
</template>

<script>
import Pagination from '../../components/Pagination.vue';
import { notify, handleError } from '../../utils/notify';
import DivSelection from '../../components/DivSelection.vue';
export default {
    components: {Pagination, DivSelection},
    data() {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth() + 1;
        const currentMonthFirstDay = `${year}-${month.toString().padStart(2, '0')}-01`;
        
        return {

            btnCalendarEditable: true, // 控制行事曆按鈕顯示與否
            divBtnVisible: false, // 控制區處部門選擇按鈕顯示與否
            selectedDiv: [],
            
            // 新增 listQuery 對象
            listQuery: {
                DivisionCode: '',
                DeptID: '',
                DateStart: '',
                DateEnd: ''
            },
            
            showCaseEdit: false, // 顯示案件編輯對話框
            selectedEvent: {}, // 選中的行事曆事件, 準備要編輯
            selectedCase: {}, // 選中的案件, 準備要編輯
            caseDetails: [ // 案件詳細資訊陣列，初始化15個元素
                { title: "案件編號", value: "" },
                { title: "到期日/限辦日期", value: "" },
                { title: "統一編號", value: "" },
                { title: "公司名稱", value: "" },
                { title: "資料來源", value: "" },
                { title: "專案名稱", value: "" },
                { title: "案件狀態", value: "" },
                { title: "預計訪視時間", value: "" },
                { title: "區處", value: "" },
                { title: "分行名稱 ", value: "" },
                { title: "覆核主管", value: "" },
                { title: "承辦人", value: "" },
                { title: "建立時間", value: "" },
                { title: "備註", value: "" },
                { title: "原因", value: "" }
            ],

            yyyyMM: new Date(),
            selyyyyMM: currentMonthFirstDay,
            filterDivisionCode: '', // 用於過濾區處部門選項的代碼
            
            BranchList: [],
            selBranch: '',
            selSales: '全部',
            // 內容菜單相關
            showMenu: false,
            menuTop: 0,
            menuLeft: 0,
            contextMenuDate: null,
            contextMenuItem: null,
            
            // 抽屜和表單相關
            drawerVisible: false,
            editDrawerVisible: false,
            selectedDate: null,
            currentEditIndex: -1,
            dayEvents: [],
            scheduleForm: {
                date: null,
                sales: 'Peter',
                target: '',
                status: '',
                Memo: '',
                startTime: '',
                endTime: ''
            },     
            branchStaffList: [],           
            calendarData: [],
            salesList: [],
            ReasonList: [
                {"客戶拒絕": ['對產品/服務不感興趣', '要求特定時間再聯繫', '暫無資金需求','已有往來行庫', '其他']},
                {"其他": ['重覆名單', '聯絡方式錯誤','聯絡不上','停歇業', '其他']},
                {"撤件": ['訪談後無意願', '要求特定時間再聯繫', '其他']}
            ],
            status_transion: [
                {'待安排訪視': ['客戶拒絕', '其他', '已安排訪視']},
                {'已安排訪視': ['已訪視']},
                {'已訪視': ['撤件', '續行申貸', '已安排訪視']}                
            ],            
            nextSelectList: [],
            showReason: false,
        }        
    },
    methods: {

        getCaseTimeTag(startTime) {
            if (!startTime) return '[上午]';

            const text = String(startTime).trim();
            const match = text.match(/(\d{1,2}):(\d{2})/);
            if (!match) return '[上午]';

            const hour = parseInt(match[1], 10);
            if (Number.isNaN(hour)) return '[上午]';

            return hour < 12 ? '[上午]' : '[下午]';
        },

        truncateText(text, maxLength = 6) {
            if (text === null || text === undefined) return '';
            const value = String(text);
            return value.length > maxLength ? `${value.slice(0, maxLength)}...` : value;
        },

        handleDivChange(val) {
            console.log("handleDivChange", val);
            // 現在 this.listQuery 已經存在，不會報錯
            this.listQuery.DivisionCode = val.DivisionCode;
            this.listQuery.DeptID = val.DeptID;
            
            // 選擇區處分行後，自動查詢行事曆
            // this.getList();

            // 如果有部門選取權限, 則不得新增或編輯該分行的行程.
            if( this.selectedDiv) {
                this.btnCalendarEditable = false;
            }
            else {
                this.btnCalendarEditable = true;
            }   
            // 有選取部門, 則再去帶出該部門的業務人員選項
            const deptID = this.listQuery.DeptID;
            this.getBranchStaff(deptID);
            
        },        
        // 檢查是否可以編輯或刪除行程
        canEditEvent(event) {
            const userInfo = this.$store.getters.userInfo;
            if (!userInfo || !userInfo.UserName) {
                return false;
            }
            return event.sales === userInfo.UserName;
        },
        
        checkReason() {
            // 判斷是否需要填寫理由, 需要找ReasonList中, 若有符合的選項, 則顯示理由填寫下拉原因.
            this.showReason = false;
            this.selectedReason = [];
            for( let i=0; i<this.ReasonList.length; i++ ){
                const key = Object.keys(this.ReasonList[i])[0];
                if( this.caseDetails[6] && key === this.caseDetails[6].value ){
                    this.showReason = true;
                    this.selectedReason = this.ReasonList[i][key];
                    break;
                }
            }

            if( !this.showReason && this.caseDetails[14] ){
                this.caseDetails[14].value = '';
            }
        },

        async getCaseDetail(row) {           
            
            const qry = { "ID": row.ID };
            //console.log("取得案件詳細資訊參數",qry);
            await this.$api.apicase.case_detail(qry).then(response => {
                //console.log("案件詳細資訊",response);                
                row = response.data;
                this.selectedCase = row;
                this.caseDetails = [
                    { title: "案件編號", value: row.CaseNo },
                    { title: "到期日/限辨期限", value: row.DueDt },
                    { title: "統一編號", value: row.UniComNm },
                    { title: "公司名稱", value: row.ComName },
                    { title: "資料來源", value: row.Source },                
                    { title: "專案名稱", value: row.ProjectName },
                    { title: "案件狀態", value: row.CaseStatus },
                    { title: "預計訪視時間", value: row.ExpectVisitDt  },
                    { title: "區處", value: row.DivisionName  },
                    { title: "分行名稱 ", value: row.DeptName  },
                    { title: "覆核主管", value: row.ApproveUserName },
                    { title: "承辦人", value: row.AssigneeUserName  },               
                    { title: "建立時間", value: row.CreateDt  },                
                    { title: "備註", value: row.Memo },
                    { title: "原因", value: "" }
                ];

                // 找出目錄CaseStatus對應的下一步狀態選項
                this.nextSelectList = [];
                for( let i=0; i<this.status_transion.length; i++ ){
                    const key = Object.keys(this.status_transion[i])[0];
                    if( key === row.CaseStatus ){
                        this.nextSelectList = this.status_transion[i][key];
                        break;
                    }
                }

                this.dialogVisible = true;

            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取案件詳細資訊失敗，請稍後再試",
                    type: "error"
                });                
            });
        }, 

        btnSaveDetail() {
            
            // 檢查showReason如果有顯示的話, caseDetails[14]不能為空
            if( this.showReason && (!this.caseDetails[14].value || this.caseDetails[14].value === '') ){
                notify({
                    title: "錯誤",
                    message: "請選擇變更原因",
                    type: "error"
                });  
                return;
            }

            // 如果選擇的是"已安排訪視", 則caseDetails[7]預計訪視時間不能為空
            if( this.caseDetails[6].value === '已安排訪視' && (!this.caseDetails[7].value || this.caseDetails[7].value === '') ){
                notify({
                    title: "錯誤",
                    message: "當案件狀態為已安排訪視時，預計訪視時間不能為空",
                    type: "error"
                });  
                return;
            }

            // 儲存動作
            //console.log("儲存案件明細", this.caseDetails);
            // 檢查如果caseDetails[7]日期有值的話, caseDetails[6]不能為空
            if( this.caseDetails[7].value && (!this.caseDetails[6].value || this.caseDetails[6].value === '') ){
                notify({
                    title: "錯誤",
                    message: "當預計訪視時間有設定時，案件狀態不能為空",
                    type: "error"
                });  
                return;
            }
            const qry = {
                "ID": this.selectedCase.ID,
                "Case_Status": this.caseDetails[6].value,
                "Expect_Visit_Dt": this.caseDetails[7].value,
                "Memo": this.caseDetails[13].value
            }
            console.log("更新案件明細參數",qry);

            // 呼叫 API 更新案件明細
            this.$api.apicase.case_update(qry).then(response => {
                console.log("更新案件明細回應",response);
                this.getList(); // 重新載入列表資料
                notify({
                    title: "成功",
                    message: "案件明細已更新",
                    type: "success"
                });
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "更新案件明細失敗，請稍後再試",
                    type: "error"
                });                
            });


            if( this.showReason) {
                //將原因記錄到案件申請覆核, 並準備申請主管覆核
                const qry = {
                    "ID": this.selectedCase.ID,
                    "Case_Reason": this.caseDetails[14].value
                }
                this.$api.apicase.case_submit_approval(qry).then(response => {
                    console.log("申請主管覆核",response);
                }).catch(error => {
                    notify({
                        title: "錯誤",
                        message: "更新案件變更原因失敗，請稍後再試",
                        type: "error"
                    });                
                });
            }
            // 關閉對話框
            this.dialogVisible = false;
        },        

        // 根據索引取得顏色類名
        getColorClass(index) {
            const colors = ['gbcGreen', 'gbcOrange', 'gbcBlue', 'gbcRed', 'gbcPurple'];
            return colors[index % colors.length];
        },
        
        changeYYYYMM(item) {
            // console.log(item);
            this.yyyyMM = item;
            
            // 切換月份時更新行程顏色
            this.updateEventColors();
        },  

        async calClick(item) {
            this.$store.dispatch("loadingHandler", true);
            //console.log(item);
            
            // 如果是事件對象，打開編輯抽屜並顯示該事件所在日期的所有事件
            if (item && item.date) {
                this.selectedDate = item.date;
                this.dayEvents = this.getDateEvents(item.date);                
                this.editDrawerVisible = true;
            } else if (item && typeof item === 'string') {
                // 如果是日期字符串，打開編輯抽屜並顯示該日期的所有事件
                this.selectedDate = item;
                this.dayEvents = this.getDateEvents(item);
                this.editDrawerVisible = true;
            }
            
            this.$store.dispatch("loadingHandler", false);
        },

        // 先判斷event.source來自case還是calendar，再進行不同的儲存邏輯
        async editCaseOrSchedule(event, index) {
            //console.log("編輯事件", this.dayEvents);
            //console.log("編輯事件索引", index);
            if (this.dayEvents[index].source === 'case') {
                // 編輯案件，先確認是否要轉址到案件管理頁面
                this.$confirm('此為案件行程，是否要轉到案件管理頁面進行編輯？', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    // 用戶確認，跳轉到案件管理頁面並傳遞 caseId
                    const caseId = this.dayEvents[index].caseId;
                    this.$router.push({
                        name: 'case-mgmt', // 需要確認 caseMgmt.vue 的路由名稱
                        query: { caseId: caseId }
                    });
                }).catch(() => {
                    // 用戶取消，不做任何操作
                    this.$message({
                        type: 'info',
                        message: '已取消編輯'
                    });
                });                
            } else {
                // 編輯行程的邏輯
                this.openEditEvent(event, index);
            }
        },
        
        // 打開事件編輯表單
        openEditEvent(event, index) {
            console.log("打開編輯事件", event);            
            this.currentEditIndex = index;
            this.scheduleForm = {
                date: event.date,
                sales: event.sales,
                target: event.title || event.target || '',
                status: event.status,
                Memo: event.memo || '',
                startTime: event.startTime || '',
                endTime: event.endTime || '',
                id: event.id || event.ID
            };
            // 關閉編輯列表抽屜，打開編輯表單抽屜
            this.editDrawerVisible = false;
            this.drawerVisible = true;
        },
        
        // 確認刪除行程
        confirmDeleteEvent(index) {
            this.$confirm('確定要刪除該行程嗎？', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteEvent(index);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消刪除'
                });
            });
        },
        
        // 刪除行程
        deleteEvent(index) {
            const event = this.dayEvents[index];
            //alert('刪除行程: ' + JSON.stringify(event));
            // 呼叫 API 刪除行程
            this.$api.apicalendar.calendar_delete({ ID: event.id }).then(res => {
                console.log('刪除行程回應', res);
                if (res.statuscode == 200) {
                    notify({
                        type: 'success',
                        message: '刪除行程成功'
                    });
                    
                    // 重新加載行程資料
                    this.getList();
                    // 並把右方的抽屜關閉
                    this.editDrawerVisible = false;
                } else {
                    notify({
                        type: 'error',
                        message: '刪除行程失敗，請稍後再試'
                    });
                }
            }).catch(error => {
                console.error('刪除行程錯誤', error);
                notify({
                    type: 'error',
                    message: '刪除行程失敗，請稍後再試'
                });
            });
        },

        // 顯示右鍵內容菜單
        showContextMenu(event, dateData, item) {
            // 阻止默認右鍵菜單
            event.preventDefault();
            
            // 檢查是否有編輯權限，沒有權限則不顯示菜單
            if (!this.btnCalendarEditable) {
                notify({
                    title: "提示",
                    message: "您沒有編輯分行行事曆的權限",
                    type: "warning"
                });
                return;
            }
            
            // 設置菜單位置
            this.menuLeft = event.clientX;
            this.menuTop = event.clientY;
            
            // 保存當前日期數據
            this.contextMenuDate = dateData;
            this.contextMenuItem = item;
            
            // 顯示菜單
            this.showMenu = true;
            
            // 點擊其他地方時隱藏菜單
            this.addHideMenuListener();
        },
        
        // 處理內容菜單選項點擊
        handleContextMenu(action) {
            const dateStr = this.contextMenuDate ? this.contextMenuDate.day : null;
            
            switch(action) {
                case 'add':
                    console.log('新增行程', dateStr);
                    // 打開抽屜並初始化表單
                    this.selectedDate = dateStr;
                    this.scheduleForm = {
                        date: dateStr,
                        sales: this.selSales !== '全部' ? this.selSales : '',
                        Title: '',
                        status: '',
                        Memo: '',
                        startTime: '10:00',
                        endTime: '12:00'
                    };
                    this.drawerVisible = true;
                    break;
                case 'view':
                    console.log('查看詳情', this.contextMenuItem);
                    // 這裡實現查看行程詳情的邏輯
                    break;
                case 'edit':
                    console.log('編輯行程', this.contextMenuItem);
                    // 打開抽屜顯示當天所有行程
                    if (this.contextMenuDate) {
                        const dateStr = this.contextMenuDate.day;
                        this.selectedDate = dateStr;
                        this.dayEvents = this.getDateEvents(dateStr);
                        this.editDrawerVisible = true;
                    }
                    break;
                case 'delete':
                    console.log('刪除行程', this.contextMenuItem);
                    // 如果右鍵選單上有特定行程項目，則直接刪除該項目
                    if (this.contextMenuItem) {
                        this.$confirm('確定要刪除該行程嗎？', '提示', {
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            // 從 calendarData 中移除該事件
                            const eventIndex = this.calendarData.findIndex(item => 
                                item.date === this.contextMenuItem.date && 
                                item.sales === this.contextMenuItem.sales && 
                                item.target === this.contextMenuItem.target && 
                                item.status === this.contextMenuItem.status
                            );
                            
                            if (eventIndex !== -1) {
                                this.calendarData.splice(eventIndex, 1);
                                this.$message({
                                    type: 'success',
                                    message: '刪除成功！'
                                });
                            }
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消刪除'
                            });
                        });
                    }
                    break;
            }
            
            // 隱藏菜單
            this.hideContextMenu();
        },
        
        // 隱藏內容菜單
        hideContextMenu() {
            this.showMenu = false;
            this.removeHideMenuListener();
        },
        
        // 添加點擊其他地方隱藏菜單的監聽器
        addHideMenuListener() {
            setTimeout(() => {
                document.addEventListener('click', this.hideContextMenu);
            }, 0);
        },
        
        // 移除監聽器
        removeHideMenuListener() {
            document.removeEventListener('click', this.hideContextMenu);
        },

        // 獲取指定日期的所有事件
        getDateEvents(date) {
            // console.log('獲取日期事件', this.calendarData.filter(event => event.date === date));
            return this.calendarData.filter(event => event.date === date) || [];
        },
        
        // 按業務人員分組事件
        groupEventsByColor(date) {
            const events = this.getVisibleEvents(date);
            const groups = {};
            
            events.forEach(event => {
                // 根據業務人員名稱和日期取得對應的顏色類名
                const colorClass = this.getSalesColorClass(event.sales, event.date);
                
                if (!groups[colorClass]) {
                    groups[colorClass] = [];
                }
                groups[colorClass].push(event);
            });
            
            return groups;
        },

        getSalesColor(salesname) {
            // 根據業務人員名稱在 salesList 中找到索引
            const salesIndex = this.salesList.findIndex(s => s.empName === salesname);
            
            // 使用業務人員的對應顏色
            const salesColorMap = {
                0: 'gbcGreen',
                1: 'gbcOrange',
                2: 'gbcBlue',
                3: 'gbcRed',
                4: 'gbcPurple'
            };
            
            return salesColorMap[salesIndex % 5] || 'gbcGrey'; // 使用模運算確保顏色循環使用
        },
        
        // 根據業務人員名稱和日期取得顏色類名
        getSalesColorClass(salesname, eventDate) {
            // 如果提供了日期參數，則判斷是否過期
            if (eventDate) {
                const today = new Date();
                today.setHours(0, 0, 0, 0); // 設置為今天的 0 時 0 分 0 秒
                
                const eventDateObj = new Date(eventDate);
                eventDateObj.setHours(0, 0, 0, 0); // 設置為事件日期的 0 時 0 分 0 秒
                
                // 如果事件日期早於今天，則表示已過期
                if (eventDateObj < today) {
                    return 'gbcGrey'; // 過期用灰色表示
                }
            }
            // 根據業務人員名稱在 salesList 中找到索引
            const salesIndex = this.salesList.findIndex(s => s.empName === salesname);
            
            // 如果沒有過期，則使用業務人員的對應顏色
            const salesColorMap = {
                0: 'gbcGreen',
                1: 'gbcOrange',
                2: 'gbcBlue',
                3: 'gbcRed',
                4: 'gbcPurple'
            };
            
            return salesColorMap[salesIndex % 5] || 'gbcGrey'; // 使用模運算確保顏色循環使用
        },
        
        // 獲取指定日期的可視事件（限制在預設數量內）
        getVisibleEvents(date) {
            const events = this.getDateEvents(date);
            const maxVisibleEvents = 2;
            return events.slice(0, maxVisibleEvents);
        },
        
        // 獲取指定日期的隱藏事件數量
        getHiddenEventsCount(date) {
            const events = this.getDateEvents(date);
            const maxVisibleEvents = 2;
            return Math.max(0, events.length - maxVisibleEvents);
        },
        
        // 儲存行程
        saveSchedule() {
            

            // this.scheduleForm.sales = this.salesList[Math.floor(Math.random() * this.salesList.length)].empName;
            // 改為目前登錄的使用人員(目前後端自行找到使用者名稱)
            const userInfo = this.$store.getters.userInfo;
            this.scheduleForm.sales = userInfo.UserName;
            console.log('儲存行程', this.scheduleForm);
            if (!this.scheduleForm.date || !this.scheduleForm.target || !this.scheduleForm.startTime || !this.scheduleForm.endTime ) {
                this.$notify({
                    title: '錯誤',
                    message: '請填寫時間及事由必填欄位',
                    type: 'error'
                });                
                return;
            }
            
            // 驗證開始時間和結束時間
            if (this.scheduleForm.startTime && this.scheduleForm.endTime) {
                // 取得小時值來比較
                const startHour = parseInt(this.scheduleForm.startTime.split(':')[0]);
                const endHour = parseInt(this.scheduleForm.endTime.split(':')[0]);
                
                if (startHour >= endHour) {
                    this.$notify({
                        title: '錯誤',
                        message: '結束時間必須比開始時間晚',
                        type: 'error'
                    });
                    return;
                }
            } else if ((this.scheduleForm.startTime && !this.scheduleForm.endTime) || 
                      (!this.scheduleForm.startTime && this.scheduleForm.endTime)) {
                this.$notify({
                    title: '錯誤',
                    message: '請同時設定開始和結束時間',
                    type: 'error'
                });
                return;
            }
            
            // 根據業務人員和日期設置背景色
            const bgcolor = this.getSalesColorClass(this.scheduleForm.sales, this.scheduleForm.date);
            
            // 判斷是新增還是編輯
            if (this.currentEditIndex !== -1) {
                // 編輯現有行程
                const eventToUpdate = this.dayEvents[this.currentEditIndex];
                
                // 呼叫 API 更新行程
                const updateData = {
                    ID: eventToUpdate.id,
                    Date: this.scheduleForm.date,
                    StartTime: this.scheduleForm.startTime || '',
                    EndTime: this.scheduleForm.endTime || '',
                    Title: this.scheduleForm.target,
                    Memo: this.scheduleForm.Memo || ''
                };
                
                console.log('更新行程參數', updateData);
                
                this.$api.apicalendar.calendar_update(updateData).then(res => {
                    console.log('更新行程回應', res);
                    if( res.statuscode==200 ) {
                        notify({
                            type: 'success',
                            message: '行程更新成功'
                        });
                        
                        // 重新載入資料
                        this.getList();
                        this.currentEditIndex = -1;
                    } else {
                        notify({
                            type: 'error',
                            message: '更新行程失敗，請稍後再試'
                        });                        
                    };                    
                }).catch(error => {
                    console.error('更新行程錯誤', error);
                    notify({
                        type: 'error',
                        message: '更新行程失敗，請稍後再試'
                    });
                });
            } else {
                // 創建新行程
                const createData = {
                    Date: this.scheduleForm.date,
                    StartTime: this.scheduleForm.startTime,
                    EndTime: this.scheduleForm.endTime,
                    Title: this.scheduleForm.target,
                    Memo: this.scheduleForm.Memo || ''
                };
                
                //console.log('新增行程', createData);  
                this.$api.apicalendar.calendar_create(createData).then(res => {
                   
                    if (res.statuscode == 200) {
                        notify({
                            type: 'success',
                            message: '新增行程成功'
                        });
                        // 重新加載行程資料
                        this.getList();
                    } else {
                        notify({
                            type: 'error',
                            message: '新增行程失敗，請稍後再試'
                        });                        
                    }
                }).catch(error => {
                    console.error('新增行程錯誤', error);
                    notify({
                        type: 'error',
                        message: '新增行程失敗，請稍後再試'
                    });
                });
            }
            
            // 更新所有行程顏色
            this.updateEventColors();
            
            // 關閉抽屜
            this.drawerVisible = false;
        },

        // 格式化時間，只保留小時部分
        formatHour(time) {
            if (!time) return '';
            if (typeof time === 'string' && time.includes(':')) {
                return time.split(':')[0] + ':00';
            }
            return time;
        },
        
        // 更新所有行程的顏色
        updateEventColors() {
            this.calendarData.forEach(event => {
                // 根據業務人員和日期更新顏色
                event.bgcolor = this.getSalesColorClass(event.sales, event.date);
            });
        },
        
        async doSearch() {
            if(this.divBtnVisible) {
                // 若出現, 則使用者必須選擇區處, 才能查詢行事曆
                if( this.selectedDiv.length ==0) {
                    notify({
                        title: "提示",
                        message: "請選擇區處後再查詢",
                        type: "warning"
                    });
                    return;
                }

            }
            if( this.selyyyyMM == '' || !this.selyyyyMM) {
                notify({
                    title: "提示",
                    message: "請選擇年月後再查詢",
                    type: "warning"
                });
                return;
            }            

            this.getList();
        },





        getList(){
            this.$store.dispatch("loadingHandler", true);
            
            // 根據選擇的年月計算起始和結束日期
            let dateStart, dateEnd;
            if (this.selyyyyMM) {
                // selyyyyMM 格式為 "yyyy-MM"
                const [year, month] = this.selyyyyMM.split('-');
                dateStart = `${year}-${month}-01`;
                
                // 計算該月的最後一天，再往後推一天（因為API只支援< dateEnd）
                const lastDay = new Date(year, month, 0).getDate();
                const endDate = new Date(year, month, lastDay + 1);
                dateEnd = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`;
            } else {
                // 若沒有則選取當月的日期
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                dateStart = `${year}-${month}-01`;
                const lastDay = new Date(year, month, 0).getDate();
                const endDate = new Date(year, month, lastDay + 1);
                dateEnd = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`;
            }
            
            const qry = {
                "DateStart": dateStart,
                "DateEnd": dateEnd
            };
            if( this.listQuery.DeptID && this.listQuery.DeptID !== '' ){
                qry.DeptID = this.listQuery.DeptID;
            };

            if( this.selSales && this.selSales !== '全部' ){
                qry.UserID = this.selSales;
            };

            console.log("取得行事曆參數", qry);
            this.$api.apicalendar.calendar_search(qry).then(res => {
                this.calendarData = res.data;
                console.log(res);
                // 從this.calendarData取得所有不同的業務人員，並更新salesList, empID及empName為 calendarData的userId, sales欄位
                const uniqueSalesMap = new Map();
                this.calendarData.forEach(item => {
                    if (item.userId && !uniqueSalesMap.has(item.userId)) {
                        uniqueSalesMap.set(item.userId, item);
                    }
                });
                this.salesList = Array.from(uniqueSalesMap.values()).map(item => ({
                    empID: item.userId,
                    empName: item.sales
                }));
                // console.log(this.salesList);


            }).catch((error) => {
                notify({
                    type: 'error',
                    message: '取得行事曆失敗，請稍後再試'
                });                        
            }).finally(() => {
                this.$store.dispatch("loadingHandler", false);
            });

        },

        // 取得分行承辦人清單
        getBranchStaff(deptID) {            
            const qry = {
                "DeptID": deptID,
                "isSys": true
            };
            console.log("獲取分行承辦人清單參數", qry);
            this.$api.apidivison.contact_list_search(qry).then(response => {
                console.log("分行承辦人清單",response);
                this.branchStaffList = response.data.filter(item => item.RoleName == "UC" || item.RoleName == "UAO")
                .map(item => ({
                    ID: item.ID,
                    UserID: item.UserID,
                    UserName: item.UserName
                }));
            }).catch(error => {
                console.error("獲取分行承辦人清單失敗", error);
                notify({
                    title: "錯誤",
                    message: "獲取分行承辦人清單失敗，請稍後再試",
                    type: "error"
                });                
            });
        },         
        // 決定分行下拉是否顯示
        async getFunctions() {
            try {
                let RoleName = [];
                let DivisionCode = '';
                const funs = this.$store.getters.userInfo;
                // console.log("使用者功能列表", funs);
                if(funs && funs.Role){
                    RoleName = funs.Role;
                    DivisionCode = funs.DivisionCode;
                    const allowedRoles = ["HE","HC1","HD","HC"];
                    let allow= false;
                    RoleName.forEach(role => {
                        if( allowedRoles.includes(role) ){
                            allow = true;
                        }
                    });
                    this.divBtnVisible = allow;
                    console.log("選取部門", allow);
                }
                else {
                    notify({
                        title: "錯誤",
                        message: "無法取得使用者功能列表，請重新登入",
                        type: "error"
                    });
                }

                // 如果有部門選取權限, 則不得新增或編輯該分行的行程.
                if( this.selectedDiv) {
                    this.btnCalendarEditable = false;
                }
                else {
                    this.btnCalendarEditable = true;
                }
                // 有例外, 若是UAO, 則可以編輯行事曆, 不因為沒有選取部門而無法編輯
                if (RoleName.includes("UAO") || RoleName.includes("UC")) {
                    this.btnCalendarEditable = true;
                }

                if( RoleName.includes("HE") || RoleName.includes("HC1") ) {
                    this.filterDivisionCode = DivisionCode;
                }

            } catch (error) {
                console.error("獲取使用者功能列表失敗", error);
                notify({
                    title: "錯誤",
                    message: "獲取使用者功能列表失敗，請稍後再試",
                    type: "error"
                });                
            }
        },        
        
    },    

    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        // await this.getBranch(this.selCity);
        this.$el.querySelector('div.el-calendar__header').remove();

        
        
        await this.getFunctions();
        if( ! this.divBtnVisible) {
            // 如果沒有部門選取權限, 則直接取得行事曆資料
            // 更新行程顏色，根據日期判斷是否過期
            this.updateEventColors();
            const deptID = this.$store.getters.deptID;
            this.getBranchStaff(deptID);
            this.getList();
        }else {
            // 有部門選取權限, 則先不取得行事曆資料, 等待使用者選取部門後再取得
            this.calendarData = [];            
        }

        this.$store.dispatch("loadingHandler", false);
    },
    
    beforeDestroy() {
        // 組件銷毀前移除事件監聽器
        this.removeHideMenuListener();
    }    
}
</script>

<style lang="scss" scoped>
// 時間信息樣式
.time-info {
    font-size: 12px;
    color: #606266;
    margin-top: 3px;
}

// 新增紫色和灰色類別
.gbcPurple {
    background-color: #9c27b0;
    color: white;
}

.gbcGrey {
    background-color: #9e9e9e;
    color: white;
}

//  * {
//      outline: 1px solid red;
//  }

/* 右鍵內容菜單樣式 */
.context-menu {
  position: fixed;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
  z-index: 2000;
  min-width: 220px; /* 增加最小寬度 */
  border: 1px solid #e0e0e0;
  overflow: hidden; /* 確保圓角效果不被子元素破壞 */
  
  .menu-Title {
    background: #f2f6fc;
    padding: 10px 15px;
    font-weight: bold;
    color: #303133;
    font-size: 16px;
    border-bottom: 1px solid #e0e0e0;
  }
  
  ul {
    list-style: none;
    margin: 0;
    padding: 0; /* 重置內邊距 */
  }
  
  li {
    padding: 14px 20px; /* 更大的按鈕內邊距 */
    cursor: pointer;
    transition: all 0.3s;
    font-size: 16px; /* 更大的字體大小 */
    display: flex;
    align-items: center;
    
    .menu-icon {
      margin-right: 12px;
      font-size: 18px;
    }
    
    &:hover {
      background-color: #ecf5ff;
      color: #409EFF;
    }
    
    &.delete-item:hover {
      background-color: #fef0f0;
      color: #f56c6c;
    }
  }
}

/* 抽屜內容樣式 */
.drawer-content {
  padding: 20px;
  
  .form-item {
    margin-bottom: 20px;
    
    label {
      display: block;
      margin-bottom: 8px;
      font-weight: bold;
    }
  }
  
  .form-actions {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    
    .el-button {
      margin-left: 10px;
    }
  }
}

#calMgmtBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;



  .gbcRed {
    background-color: #f08080;
  }
  .gbcOrange {
    background-color: #fc9;
  }
  .gbcBlue {
    background-color: #add8e6;
  }
  .gbcGreen {
    background-color: #90ee90;
  }

  /* 日曆單元格樣式 */
  .main-cd {
    min-height: 100px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 2px;
    position: relative;
  }

  /* 日期數字樣式 */
  .date-number {
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 4px;
    text-align: center;
  }

  /* 行程容器樣式 */
  .event-container {
    display: flex;
    flex-direction: column;
    gap: 2px;
    position: relative;
    flex-grow: 1;
    max-height: calc(100% - 24px); /* 留出日期的空間 */
    overflow: hidden; /* 預設隱藏滿出內容 */
  }

  /* 單元格懸停時顯示完整內容 */
  .main-cd:hover .event-container {
    position: absolute;
    z-index: 10;
    background: white;
    width: calc(100% - 4px); /* 減去 padding */
    max-height: none;
    overflow: visible;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    padding: 2px;
  }

  /* 單個日期的所有事件容器 */
  .day-events {
    display: flex;
    flex-wrap: wrap; /* 允許事件群組換行 */
    gap: 3px;
  }

  /* 相同狀態的事件組 */
  .event-group {
  display: inline-flex; /* 改為 inline-flex 使其不佔滿整行 */
  flex-wrap: wrap;
  gap: 4px;
  padding: 3px 5px;
  border-radius: 3px;
  margin-bottom: 1px;
  margin-right: 5px; /* 增加右側間距 */
  }

  /* 客戶標簽樣式 */
  .customer-tag {
    font-weight: bold;
    color: black;
    font-size: 11px;
    cursor: pointer;
    border-radius: 2px;
    transition: all 0.2s;
    padding: 0 3px;
  }

  .customer-tag:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  
  /* 懸停時的效果 */
  .main-cd:hover .customer-tag {
    font-size: 12px;
  }
  
  /* 更多行程提示 */
  .more-events {
    font-size: 11px;
    text-align: center;
    color: #606060;
    background-color: #f2f2f2;
    border-radius: 3px;
    padding: 2px;
    margin-top: 1px;
    cursor: pointer;
  }




  .dialogBox {
    display: flex;
    flex-direction: column;;    
    justify-content: flex-start;
    padding: 0px 5%;

  .details-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px 25px;
    padding: 15px;
  }

  .detail-row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    // padding: 8px 10px;
    border-bottom: 1px solid #ebeef5;
    // min-height: 40px;
    
    .detail-label {
      min-width: 110px;
      max-width: 110px;
      font-weight: bold;
      color: #303133;
      text-align: right;
      padding-right: 12px;
      font-size: 14px;
      padding-top: 8px;
      flex-shrink: 0;
    }
    
    .detail-content {
      flex: 1;
      color: #606266;
      font-size: 14px;
      padding-top: 5px;
      word-break: break-word;
    }
  }    
    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }
    }
  }


  .searchWrap   {
    display: flex;
    flex-direction: row;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
        display: flex;
        flex-direction: row;    
        justify-content: center;

        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin: 10px 5px;                        
            label {
                margin-right: 10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
        }
        

    }
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        align-items: center;
        label {
            font-weight: bold;            
            margin-right: 10px;
        }        
        .legendItem {
            width: 120px;
            margin: 5px 10px;
        }
        
        .legend-color {
            width: 100%;
            box-sizing: border-box;
            
            font-size: small;
            color: black;
            padding: 5px 5px;    
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }
}

/* 編輯行程抽屜樣式 */
.day-events-list {
    max-height: calc(100vh - 250px);
    overflow-y: auto;
}

.no-events {
    text-align: center;
    margin: 20px 0;
    color: #909399;
    font-size: 14px;
}

.event-item {
    margin-bottom: 15px;
    padding: 12px;
    border-radius: 4px;
    border-left: 4px solid transparent;
    background-color: #f5f7fa;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.event-content {
    flex: 1;
}

.event-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;    
}

.event-Title {
    font-weight: bold;
    font-size: 16px;
    flex: 1; /* 佔滿剩餘空間，使後面的元素靠右 */
}

.event-status {
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 12px;
    background-color: #f0f0f0;
    margin-left: 6px; /* 兩個 status 之間保留間距 */
    white-space: nowrap;
}

.event-details {
    font-size: 14px;
    color: #606266;
    line-height: 1.5;
}

.event-actions {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-end;
    min-width: 80px;
}

/* 根據事件類型的顏色 */
.event-item.gbcGreen {
    border-left-color: #67c23a;
}

.event-item.gbcOrange {
    border-left-color: #e6a23c;
}

.event-item.gbcBlue {
    border-left-color: #409eff;
}

.event-item.gbcRed {
    border-left-color: #f56c6c;
}


</style>